import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="terms-hero py-5" style={{
        background: 'var(--gradient-hero)',
        color: 'white',
        paddingTop: '180px',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, var(--accent-500) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, var(--accent-400) 0%, transparent 50%)
          `,
          opacity: '0.06',
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h1 style={{
                fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                fontWeight: '800',
                marginBottom: '1rem',
                color: 'var(--primary-50)',
                textShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
              }}>
                Terms of Service
              </h1>
              <p style={{
                fontSize: '1.2rem',
                color: 'rgba(255, 255, 255, 0.9)',
                maxWidth: '600px',
                margin: '0 auto',
                fontWeight: '500'
              }}>
                Last updated: January 15, 2025
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-5" style={{ 
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        position: 'relative'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 10% 20%, rgba(14, 165, 233, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 90% 80%, rgba(14, 165, 233, 0.02) 0%, transparent 50%)
          `,
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div style={{
                background: 'rgba(255, 255, 255, 0.9)',
                padding: '3rem',
                borderRadius: '24px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(14, 165, 233, 0.1)',
                backdropFilter: 'blur(10px)'
              }}>
                <div style={{ color: '#374151', lineHeight: '1.8' }}>
                                    <h2 style={{ color: '#334155', marginBottom: '1.5rem', fontWeight: '700' }}>
                    1. Acceptance of Terms
                   </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    By accessing and using the <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> website, services, and platforms (collectively, the "Services"), you accept and agree to be bound by these Terms of Service ("Terms"). These Terms constitute a legally binding agreement between you and <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> ("we," "our," "us," or "<span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span>").
                  </p>
                  <p style={{ marginBottom: '1.5rem' }}>
                    If you do not agree to these Terms, you must not access or use our Services. We reserve the right to modify these Terms at any time, and such modifications will be effective immediately upon posting on our website.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    2. Description of Services
                  </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> provides comprehensive AI consulting, development, and implementation services, including but not limited to:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Generative AI Solutions:</strong> Custom AI model development, content generation, and intelligent automation</li>
                    <li><strong>Machine Learning & Deep Learning:</strong> Predictive analytics, pattern recognition, and data-driven insights</li>
                    <li><strong>Natural Language Processing:</strong> Text analysis, sentiment analysis, and conversational AI</li>
                    <li><strong>Chatbot Development:</strong> Intelligent customer service and engagement solutions</li>
                    <li><strong>SaaS Product Development:</strong> Scalable software-as-a-service applications</li>
                    <li><strong>Custom Software Development:</strong> Bespoke applications and system integration</li>
                    <li><strong>Data Engineering:</strong> Data pipelines, analytics platforms, and business intelligence</li>
                    <li><strong>AI Strategy & Consulting:</strong> Digital transformation and AI adoption guidance</li>
                    <li><strong>Staff Augmentation:</strong> AI and technology talent on demand</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    3. User Responsibilities and Conduct
                  </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    As a user of our Services, you agree to:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Provide Accurate Information:</strong> Furnish complete, accurate, and current information</li>
                    <li><strong>Maintain Security:</strong> Protect your account credentials and notify us of any unauthorized access</li>
                    <li><strong>Comply with Laws:</strong> Use our Services in accordance with applicable laws and regulations</li>
                    <li><strong>Respect Intellectual Property:</strong> Honor copyright, trademark, and other intellectual property rights</li>
                    <li><strong>Prohibited Activities:</strong> Not engage in hacking, reverse engineering, or other malicious activities</li>
                    <li><strong>Data Responsibility:</strong> Ensure you have the right to provide any data or content to us</li>
                    <li><strong>Professional Conduct:</strong> Maintain professional and respectful communication</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    4. Intellectual Property Rights
                  </h2>
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>4.1 Our Intellectual Property</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    All content, features, and functionality on our website and Services, including but not limited to text, graphics, logos, software, algorithms, methodologies, and trade secrets, are owned by <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> and are protected by copyright, trademark, patent, and other intellectual property laws.
                  </p>
                  
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>4.2 Client Intellectual Property</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    Custom solutions developed specifically for clients become the property of the client upon full payment, subject to the following conditions:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Client retains ownership of their proprietary data and business logic</li>
                    <li><span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> retains rights to general methodologies, frameworks, and reusable components</li>
                    <li>Third-party software and libraries remain subject to their respective licenses</li>
                    <li>Intellectual property rights are detailed in individual project agreements</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    5. Payment Terms and Billing
                  </h2>
                  <p style={{ marginBottom: '1rem' }}>
                    Payment terms are specified in individual project agreements and statements of work. General terms include:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Project Deposits:</strong> Typically 25-50% of total project value before work begins</li>
                    <li><strong>Milestone Payments:</strong> Scheduled payments tied to project milestones and deliverables</li>
                    <li><strong>Payment Terms:</strong> Net 30 days from invoice date unless otherwise specified</li>
                    <li><strong>Late Fees:</strong> 1.5% monthly interest on overdue amounts</li>
                    <li><strong>Currency:</strong> All amounts are in USD unless otherwise agreed</li>
                    <li><strong>Taxes:</strong> Client is responsible for applicable taxes and duties</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    6. Confidentiality and Data Protection
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    We maintain strict confidentiality regarding client information, project details, and proprietary data. Our confidentiality obligations include:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Non-Disclosure:</strong> We will not disclose confidential information to third parties without written consent</li>
                    <li><strong>Data Security:</strong> Implementation of industry-standard security measures</li>
                    <li><strong>Access Controls:</strong> Limited access to confidential information on a need-to-know basis</li>
                    <li><strong>Return/Destruction:</strong> Return or destroy confidential information upon project completion</li>
                    <li><strong>Legal Exceptions:</strong> Disclosure may be required by law or court order</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    7. AI Ethics and Responsible Development
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    We are committed to responsible AI development and ethical practices:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Bias Mitigation:</strong> We actively work to identify and reduce bias in AI models</li>
                    <li><strong>Transparency:</strong> We provide clear explanations of AI system capabilities and limitations</li>
                    <li><strong>Human Oversight:</strong> We maintain appropriate human supervision of AI systems</li>
                    <li><strong>Privacy Protection:</strong> We implement privacy-by-design principles in all AI solutions</li>
                    <li><strong>Regular Audits:</strong> We conduct periodic reviews of AI systems for fairness and accuracy</li>
                    <li><strong>Compliance:</strong> We ensure AI solutions comply with applicable regulations and standards</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    8. Service Level Agreements and Warranties
                  </h2>
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>8.1 Service Quality</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    We strive to deliver high-quality services and solutions. However, our services are provided "as is" and "as available" without warranties of any kind, either express or implied.
                  </p>
                  
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>8.2 Performance Guarantees</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    Specific performance guarantees and service level agreements are detailed in individual project contracts and may include:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Response times for support requests</li>
                    <li>System uptime and availability</li>
                    <li>Model accuracy and performance metrics</li>
                    <li>Project delivery timelines</li>
                    <li>Quality assurance standards</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    9. Limitation of Liability
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    To the maximum extent permitted by law, <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Loss of profits, revenue, or business opportunities</li>
                    <li>Loss of data or information</li>
                    <li>Interruption of business operations</li>
                    <li>Reputational damage</li>
                    <li>Third-party claims or damages</li>
                  </ul>
                  <p style={{ marginBottom: '1.5rem' }}>
                    Our total liability shall not exceed the amount paid by you for the specific service giving rise to the claim.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    10. Indemnification
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    You agree to indemnify and hold harmless <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> from and against any claims, damages, losses, and expenses arising from:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Your use of our Services</li>
                    <li>Your violation of these Terms</li>
                    <li>Your violation of any third-party rights</li>
                    <li>Your provision of inaccurate or unauthorized data</li>
                    <li>Your failure to comply with applicable laws or regulations</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    11. Termination and Suspension
                  </h2>
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>11.1 Termination by You</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    You may terminate your use of our Services at any time by providing written notice. Termination will be effective upon our receipt of notice.
                  </p>
                  
                  <h3 style={{ color: '#374151', marginBottom: '1rem', fontWeight: '600' }}>11.2 Termination by Us</h3>
                  <p style={{ marginBottom: '1rem' }}>
                    We may terminate or suspend your access to our Services immediately, without prior notice, for:
                  </p>
                  <ul style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li>Violation of these Terms</li>
                    <li>Non-payment of fees</li>
                    <li>Fraudulent or illegal activities</li>
                    <li>Security threats or unauthorized access</li>
                    <li>Extended periods of inactivity</li>
                  </ul>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    12. Force Majeure
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    Neither party shall be liable for any failure or delay in performance due to circumstances beyond their reasonable control, including but not limited to natural disasters, government actions, labor disputes, or technical failures.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    13. Governing Law and Jurisdiction
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    These Terms shall be governed by and construed in accordance with the laws of the State of Texas, United States, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Travis County, Texas.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    14. Dispute Resolution
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    In the event of any dispute arising from these Terms or our Services, we encourage resolution through the following steps:
                  </p>
                  <ol style={{ marginBottom: '1.5rem', paddingLeft: '1.5rem' }}>
                    <li><strong>Direct Communication:</strong> Parties will attempt to resolve disputes through good faith negotiations</li>
                    <li><strong>Mediation:</strong> If direct communication fails, parties may engage in mediation</li>
                    <li><strong>Arbitration:</strong> If mediation is unsuccessful, disputes shall be resolved through binding arbitration in Austin, Texas</li>
                    <li><strong>Court Action:</strong> Either party may seek injunctive relief in court to prevent irreparable harm</li>
                  </ol>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    15. Severability and Waiver
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    If any provision of these Terms is found to be unenforceable or invalid, the remaining provisions will continue in full force and effect. The failure to enforce any right or provision of these Terms shall not constitute a waiver of such right or provision.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    16. Entire Agreement
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    These Terms, together with any project agreements, statements of work, and privacy policy, constitute the entire agreement between you and <span style={{ color: '#0ea5e9', fontWeight: '600' }}>Vallen AI</span> regarding the use of our Services, superseding any prior agreements or understandings.
                  </p>

                  <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontWeight: '700' }}>
                    17. Contact Information
                  </h2>
                  <p style={{ marginBottom: '1.5rem' }}>
                    For questions about these Terms of Service or to exercise your rights, please contact us:
                  </p>
                  <div style={{
                    background: '#f8fafc',
                    padding: '1.5rem',
                    borderRadius: '12px',
                    border: '1px solid #e2e8f0'
                  }}>
                    <p style={{ marginBottom: '0.5rem' }}>
                      <strong>Email:</strong> legal@vallenai.com
                    </p>
                    <p style={{ marginBottom: '0.5rem' }}>
                      <strong>Address:</strong> Austin Texas, United States<br />
                      <small style={{color: '#94a3b8', fontStyle: 'italic'}}>
                        Temporary address - Not a physical office
                      </small>
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>General Inquiries:</strong> contact@vallenai.com
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-5" style={{
        background: 'var(--gradient-hero)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Background Pattern */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 80%, var(--accent-500) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, var(--accent-400) 0%, transparent 50%)
          `,
          opacity: '0.06',
          zIndex: 1
        }}></div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h3 style={{
                color: 'var(--primary-50)',
                marginBottom: '1rem',
                fontWeight: '700',
                fontSize: 'clamp(1.5rem, 3vw, 2rem)'
              }}>Questions About Our Terms?</h3>
              <p style={{
                color: 'rgba(255, 255, 255, 0.9)',
                marginBottom: '2rem',
                fontSize: '1.1rem'
              }}>
                Our legal team is here to help clarify any questions about our terms of service and ensure a clear understanding of our partnership.
              </p>
              <Link to="/contact" style={{
                background: 'linear-gradient(135deg, var(--accent-500) 0%, var(--accent-600) 100%)',
                border: 'none',
                color: '#ffffff',
                padding: '1rem 2rem',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '200px',
                boxShadow: '0 8px 25px rgba(14, 165, 233, 0.4)',
                transition: 'all 0.3s ease'
              }}>
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsPage; 